module.exports = __webpack_public_path__ + "static/media/Livre1.3e576f60.png";